export enum PlaceResultTypeEnum {
  PLACE = "place",
  REGION = "region",
  VENUE = "venue",
}

export enum SitewideResultTypeEnum {
  CONTENT = "content",
  PLACE = PlaceResultTypeEnum.PLACE,
  REGION = PlaceResultTypeEnum.REGION,
  VENUE = PlaceResultTypeEnum.VENUE,
}
